// extracted by mini-css-extract-plugin
export default {"filesMenu":"files-menu_filesMenu__9dLK4","fileContainer":"files-menu_fileContainer__Q7BmS","fileName":"files-menu_fileName__3i8bK","actions":"files-menu_actions__oNfbq"};